import { JsonPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { FacebookFormLogs } from 'src/app/core/models/social-forms-configurations/facebook-form-configuration.model';

@Pipe({
    name: 'humanizeLogPayload',
    pure: true,
    standalone: false
})
export class HumanizeLogPayloadPipe implements PipeTransform {


  /**
   *
   */
  constructor(private readonly jsonPipe: JsonPipe) {

  }
  transform(value: FacebookFormLogs | null | undefined): string {
    if (!value) return ''
    return this.jsonPipe.transform(value.leads)
  }

}
